<template>
  <div>
    <div class="content_item">
      <div class="title">确认订单地址</div>
      <div class="address">
        <!-- ie错乱bug 再包一层 -->
        <div class="content">
          <div class="item" :class="deliveryAddrId == item.id ? 'active' : ''" v-for="(item, index) in addrList" :key="index" @click="sureAddrId(item)">
            <div class="top">
              <el-tooltip :open-delay="500" popper-class="new_popper1" :visible-arrow="false" effect="light" :offset="0" :content="item.deliveryPerson" placement="bottom-end">
                <p class="name com_hidden">{{ item.deliveryPerson }}</p>
              </el-tooltip>
              <el-tooltip :open-delay="500" popper-class="new_popper1" :visible-arrow="false" effect="light" :offset="0" :content="item.provinceName + ' ' + item.cityName" placement="bottom-end">
                <p class="addr com_hidden">
                  {{ item.provinceName + " " + item.cityName }}
                </p>
              </el-tooltip>
            </div>
            <div class="middle">
              <span class="detail_addr">
                {{item.disName + " " + item.townName + " " + item.detailAddr}}
              </span>
              <span>{{ item.telNo }}</span>
            </div>
            <div class="bottom">
              <span class="edit_btn com_link" @click.stop="updateAddrAction(item)">修改</span>
              <span class="del_btn com_link" @click.stop="delAddr(item.id)">删除</span>
            </div>
          </div>
          <div class="add_item item">
            <p class="com_link" @click="addDialogAddr">
              <i class="el-icon-plus add_icon"></i>
              <span>添加新地址</span>
            </p>
          </div>
        </div>
      </div>
      <el-dialog class="dialog_addr" title="编辑收货人信息" :visible.sync="dialogAddr" :close-on-press-escape="false" :close-on-click-modal="false" top="25vh" width="600px" @close="clearFormData">
        <el-form ref="addrForm" :model="addrFormData" :rules="rules" label-width="120px" label-position="left">
          <el-form-item label="所在地区" prop="place">
            <cascader-city ref="casCity" :GetProList="GetProList" :GetDisList="GetDisList" :GetTownList="GetTownList" @getEndPlace="getEndPlace"></cascader-city>
          </el-form-item>
          <el-form-item label="收货人" prop="deliveryPerson">
            <el-input v-model="addrFormData.deliveryPerson" placeholder="请输入收货人姓名"></el-input>
          </el-form-item>
          <el-form-item label="详细地址" prop="detailAddr">
            <el-input v-model.trim="addrFormData.detailAddr" placeholder="请输入详细地址"></el-input>
          </el-form-item>
          <el-form-item label="手机号码" prop="telNo">
            <el-input v-model="addrFormData.telNo" placeholder="请输入手机号码"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="clearFormData">取 消</el-button>
          <el-button type="primary" :loading="editLoading" @click="updateAddr" v-if="addrFormData.id">修 改</el-button>
          <el-button type="primary" :loading="addLoading" @click="addAddr" v-else>确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  GetAddrList,
  AddAddress,
  UpdateAddress,
  DelAddress,
} from "@/pages/page1/api/modules/user";
import {
  GetProList,
  GetDisList,
  GetTownList,
} from "@/pages/page1/api/modules/common";
import { checkMobile, validatetypeName } from "@/pages/publicUtils/validate";
import CascaderCity from "@/components/cascaderCity";
export default {
  components: {
    CascaderCity,
  },
  data() {
    let checkName = (rule, value, callback) => {
      // console.log(value, validatetypeName(value));
      if (!value) {
        return callback(new Error("必填"));
      }
      if (value.length < 2 || value.length > 12) {
        return callback(new Error("最少2个最多12个字符"));
      }
      if (!validatetypeName(value)) {
        return callback(new Error("请输入中文或英文姓名"));
      }
      callback();
    };
    return {
      GetProList,
      GetDisList,
      GetTownList,
      // 收货地址
      pageInfo: {
        pageNumber: 1,
        pageSize: 20,
        searchProperty: [
          {
            searchFiled: "",
            searchValue: "",
          },
        ],
        orderProperty: [],
      },
      regionCode: "",
      deliveryAddrId: "",
      addrList: [],
      addrFormData: {
        id: "",
        place: "",
        deliveryPerson: "",
        detailAddr: "",
        telNo: "",
        isDefault: 0,
        provinceCode: "",
        cityCode: "",
        disCode: "",
        townId: "",
        provinceName: "",
        cityName: "",
        disName: "",
        townName: "",
        needCheck: 1,
      },
      dialogAddr: false,
      rules: {
        place: [{ required: true, message: "必选", trigger: "change" }],
        detailAddr: [
          { required: true, message: "必填", trigger: "blur" },
          {
            min: 1,
            max: 120,
            message: "长度在 1 到 120 个字符",
            trigger: "blur",
          },
        ],
        deliveryPerson: [
          { validator: checkName, required: true, trigger: "blur" },
        ],
        telNo: [{ validator: checkMobile, required: true, trigger: "blur" }],
      },
      addLoading: false,
      editLoading: false,
    };
  },
  methods: {
    // 地址
    getAddrList() {
      GetAddrList({ pageInfo: this.pageInfo }).then((res) => {
        // console.log("获取地址列表", res.data);
        this.addrList = res.data;
        // 初始化确认地址为第一个
        if (!this.deliveryAddrId) {
          this.sureAddrId(this.addrList[0]);
        } else {
          // 找到对应id
          let resItem = this.addrList.find((v) => v.id === this.deliveryAddrId);
          this.sureAddrId(resItem);
        }
      });
    },
    addDialogAddr() {
      if (this.addrList.length >= 20) {
        this.$alert(
          "您的收货地址已有20个，请删除其他无效地址后，再来添加",
          "提示",
          {
            confirmButtonText: "确定",
            type: "warning",
            showClose: false,
          }
        );
      } else {
        this.dialogAddr = true;
      }
    },
    addAddr() {
      this.$refs.addrForm.validate((valid) => {
        if (valid) {
          this.addLoading = true;
          AddAddress(this.addrFormData)
            .then((res) => {
              // console.log("新增地址接口", res);
              this.addLoading = false;
              this.clearFormData();
              this.$message({
                message: "新增成功",
                type: "success",
              });
              this.getAddrList();
            })
            .catch((err) => {
              this.addLoading = false;
            });
        } else {
          return false;
        }
      });
    },
    updateAddrAction(item) {
      // console.log(item);
      this.dialogAddr = true;
      this.addrFormData = {
        id: item.id,
        place: "回填的值",
        deliveryPerson: item.deliveryPerson,
        detailAddr: item.detailAddr,
        telNo: item.telNo,
        isDefault: item.isDefault,
        provinceCode: item.provinceCode,
        cityCode: item.cityCode,
        disCode: item.disCode,
        townId: item.townId,
        provinceName: item.provinceName,
        cityName: item.cityName,
        disName: item.disName,
        townName: item.townName,
        needCheck: 1,
      };
      let codeArr = [
        item.provinceCode,
        item.cityCode,
        item.disCode,
        item.townId,
      ];
      // dom 更新以后
      this.$nextTick(() => {
        this.$refs.casCity.setValue(codeArr);
      });
    },
    updateAddr() {
      this.$refs.addrForm.validate((valid) => {
        if (valid) {
          this.editLoading = true;
          UpdateAddress(this.addrFormData)
            .then((res) => {
              // console.log("修改地址", res);
              this.editLoading = false;
              this.clearFormData();
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.getAddrList();
            })
            .catch((err) => {
              this.editLoading = false;
            });
        } else {
          return false;
        }
      });
    },
    delAddr(id) {
      this.$confirm("此操作会永久删除地址, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          DelAddress({ id }).then((res) => {
            // console.log("删除接口", res);
            if (this.deliveryAddrId === id) {
              this.deliveryAddrId = "";
            }
            this.getAddrList();
          });
        })
        .catch(() => {});
    },
    getEndPlace(val) {
      if (val.label.length == 0) {
        this.addrFormData.place = "";
      } else {
        this.addrFormData.place = "赋值满足要求";
      }
      this.addrFormData.provinceCode = val.value[0];
      this.addrFormData.cityCode = val.value[1];
      this.addrFormData.disCode = val.value[2];
      this.addrFormData.townId = val.value[3];
      this.addrFormData.provinceName = val.label[0];
      this.addrFormData.cityName = val.label[1];
      this.addrFormData.disName = val.label[2];
      this.addrFormData.townName = val.label[3];
      // console.log(val, this.addrFormData);
    },
    clearFormData() {
      this.$refs.addrForm.resetFields();
      for (const key in this.addrFormData) {
        this.addrFormData[key] = "";
        if (key === "needCheck") {
          this.addrFormData[key] = 1;
        }
      }
      this.$refs.casCity.value = [];
      this.dialogAddr = false;
    },
    sureAddrId(item) {
      if (!item) {
        this.regionCode = null;
        this.deliveryAddrId = "";
        this.$emit("sureAddress", {
          regionCode: this.regionCode,
          deliveryAddrId: this.deliveryAddrId,
          resAddr: "",
          consignee: "",
          addrLength: this.addrList.length,
        });
        return;
      }
      let phone = item.telNo.replace(/^(\d{3})\d{4}(\d+)/, "$1****$2");
      this.deliveryAddrId = item.id;
      this.regionCode = item.disCode;
      let resAddr =
        item.provinceName +
        " " +
        item.cityName +
        " " +
        item.disName +
        " " +
        item.townName +
        " " +
        item.detailAddr;
      let consignee = item.deliveryPerson + " （" + phone + "）";
      this.$emit("sureAddress", {
        regionCode: this.regionCode,
        deliveryAddrId: this.deliveryAddrId,
        resAddr,
        consignee,
        addrLength: this.addrList.length,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content_item {
  margin-bottom: 30px;
  position: relative;
  .title {
    font-size: 24px;
    font-weight: bold;
    padding-bottom: 26px;
    .tit_itr {
      font-size: 12px;
      font-weight: 500;
      color: #909090;
      padding-left: 18px;
    }
    .reback_cart {
      width: 132px;
      height: 30px;
      line-height: 30px;
      padding: 0px;
      float: right;
      margin-right: 30px;
      border-radius: 0px;
    }
  }
  .address {
    max-height: 342px;
    overflow-y: auto;
    overflow-x: hidden;
    .content {
      display: flex;
      flex-wrap: wrap;
      font-weight: bold;
      .item {
        width: calc((100% - 42px) / 4);
        height: 156px;
        overflow: hidden;
        box-sizing: border-box;
        padding: 16px;
        padding-left: 10px;
        background: url("~@/assets/img/dz.png") no-repeat 100% center;
        background-size: 100%;
        margin-top: 30px;
        margin-right: 14px;
        position: relative;
        opacity: 0.5;
        cursor: pointer;
        &:nth-child(4n) {
          margin-right: 0px;
        }
        &:nth-child(-n + 4) {
          margin-top: 0px;
        }
        .top {
          padding-bottom: 12px;
          border-bottom: 1px solid #e5e5e5;
          padding-left: 6px;
          font-size: 14px;
          margin-bottom: 14px;
          display: flex;
          align-items: center;
          .name {
            margin-right: 30px;
            min-width: 56px;
          }
          .addr {
            max-width: calc(100% - 86px);
          }
        }
        .middle {
          font-size: 12px;
          color: #909090;
          line-height: 24px;
          padding-left: 6px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;

          .detail_addr {
            padding-right: 14px;
          }
        }
        .bottom {
          font-size: 14px;
          padding-left: 6px;
          color: #909090;
          box-sizing: border-box;
          position: absolute;
          bottom: 16px;
          left: auto;
          .edit_btn,
          .del_btn {
            display: inline-block;
          }
          .edit_btn {
            margin-right: 16px;
            color: @themeColor;
          }
        }
      }
      .add_item {
        font-size: 28px;
        font-weight: 500;
        color: #909090;
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 1;
        .add_icon {
          margin-right: 26px;
        }
      }
      .active {
        position: relative;
        opacity: 1;
        &::before {
          content: " ";
          position: absolute;
          bottom: -20px;
          right: -5px;
          display: block;
          height: 0;
          width: 0;
          border-bottom: 30px solid transparent;
          border-left: 30px solid @themeColor;
          border-top: 30px solid transparent;
          transform: rotate(45deg);
          -ms-transform: rotate(45deg);
          -moz-transform: rotate(45deg);
          -webkit-transform: rotate(45deg);
          -o-transform: rotate(45deg);
        }
        &::after {
          content: " ";
          display: block;
          position: absolute;
          bottom: 2px;
          right: 2px;
          width: 26px;
          height: 21px;
          background: url("~@/assets/img/gg.png") no-repeat 100% center;
          background-size: contain;
        }
      }
    }
  }
  .dialog_addr {
    /deep/ .el-dialog {
      height: 400px;
      border: 4px solid #a3a3a3;
      font-size: 12px;
      color: #1a1a1a;
      .el-dialog__header {
        padding: 0px;
        height: 24px;
        line-height: 24px;
        background: #e5e5e5;
        .el-dialog__title {
          padding-left: 18px;
          font-size: 12px;
          color: #1a1a1a;
          font-weight: bold;
        }
        .el-dialog__headerbtn {
          top: 1px;
        }
      }
      .el-dialog__body {
        padding: 60px 106px;
        .el-form {
          .el-form-item {
            margin-bottom: 20px;
            .el-form-item__label {
              line-height: 24px;
              color: #000000;
            }
            .el-form-item__content {
              line-height: 24px;
              width: 260px;
              .el-input {
                .el-input__inner {
                  height: 24px;
                  line-height: 24px;
                }
              }
              .btn {
                border-radius: 0px;
              }
              .el-form-item__error {
                color: @themeColor;
              }
              .cascader {
                .el-cascader,
                .else_cas {
                  width: 260px !important;
                  min-width: auto !important;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>